import ApiClient from './axios-wrapper';
import { AddressViaCepRes } from './viacep.types';

const api = new ApiClient({
  baseURL: 'https://viacep.com.br/ws/',
  withCredentials: false,
});

class ViaCepService {
  async getAddress(postalCode: string) {
    return await api.get<AddressViaCepRes>(`${postalCode}/json`);
  }
}

export const viaCepService = new ViaCepService();
